import React from 'react';
import InsightsTab from './InsightsTab';
import { OverviewTab } from './OverviewTab';
import { TasksTab } from './TasksTab';
import ComingSoon from '../../../components/common/ComingSoon';
import CadenceRuleList from '../../../components/cadence/CadenceRuleList';
import { CADENCE_MODULE_TYPES } from '../../../components/cadence/cadenceModuleTypes';
import '../../../components/layout/ModuleLayout.css';
import { PMTabKey } from './ProjectManagementTabs';

interface ProjectManagementNetBodyProps {
  activeTab?: PMTabKey;
}

const ProjectManagementNetBody: React.FC<ProjectManagementNetBodyProps> = ({ activeTab = 'insights' }) => {
  const renderPanel = () => {
    if (activeTab === 'insights') return <InsightsTab />;
    if (activeTab === 'projects') return <OverviewTab />;
    if (activeTab === 'tasks')    return <TasksTab />;
    if (activeTab === 'cadence')  return <CadenceRuleList allowedTypeCodes={CADENCE_MODULE_TYPES.project} />;
    return <ComingSoon />;
  };

  return (
    <div className="module-layout">
      <div className="module-main">
        <div className="tab-content">
          <section role="tabpanel" className="tab-panel show">
            {renderPanel()}
          </section>
        </div>
      </div>
    </div>
  );
};

export { ProjectManagementNetBody };
export default ProjectManagementNetBody;
